import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack, CardStackSummary } from "@shared/models/card-stack"
import type { Course, Unit } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type EmberStore from "cc-frontend/services/ember-store"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import type ModalManager from "cc-frontend/services/modal-manager"
import styles from "./header.module.css"

@tagName("")
export default class UnitHeader extends Component {
  readonly styles = styles

  // Args
  modelsNeededForFirstEdit!: ModelsNeededForFirstEdit
  unitCardStack!: CardStack
  course!: Course
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  unitInfo!: Unit
  editCourseTitleAndOrder!: Function
  unitCardStackIsFulfilled!: boolean
  units!: Array<CardStackSummary>

  //Services
  @service("ember-store") store!: EmberStore
  @service lessonEditor!: LessonEditor
  @service modalManager!: ModalManager

  // Props
  lessonMenuConstraints = [{ to: "window", pin: ["left"] }]
  canShowUnitMenu: boolean = false

  @action
  onTitleEdited(value) {
    this.lessonEditor.editTitle(this.modelsNeededForFirstEdit, this.unitCardStack.id, value, false)
  }

  @action
  onFinishedEditingTitle(value, originalValue) {
    this.lessonEditor.finishEditingTitle(
      this.modelsNeededForFirstEdit,
      this.unitCardStack.id,
      value,
      originalValue
    )
  }

  @action
  toggleCardMenu() {
    set(this, "canShowUnitMenu", !get(this, "canShowUnitMenu"))
  }
}
